import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Checkbox, Collapse, Fade, FormControl, FormErrorMessage, FormHelperText, FormLabel, Heading, HStack, Icon, Input, List, ListItem, OrderedList, ScaleFade, Stack, Text, useDisclosure, VStack, Link, Image, Select, calc, Modal } from "@chakra-ui/react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import GreyBox from '../style/components/greyBox';
import { FaAngleDown, FaAsterisk } from "react-icons/fa";
import { useEffect, useState } from "react";
import Signature from "../style/components/signature";
import { AnimatePresence } from "framer-motion";
import AlertErrors from "../style/components/alertErrors";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import he from "date-fns/locale/he";
import "../style/css/datepicker.css";
import moment from "moment";
import api from "../services/api";
import FullScreenLoader from "../style/components/fullScreenLoader";

export default function MaslekaForm({ initialData }) {

  const { register, handleSubmit, reset, formState: { errors, isValid, isDirty, touchedFields }, control, setValue, trigger, watch } = useForm({
    mode: 'onChange',
    defaultValues: {
      excludedProducts: [{ accountNumber: "", code: "" }]
    }
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "excludedProducts",
  });

  const lastNameValue = watch('lastName');
  const firstNameValue = watch('firstName');
  const idNumberValue = watch('idNumber');
  const cityNameValue = watch('cityName');
  const streetValue = watch('street');
  const houseNumberValue = watch('houseNumber');
  const phoneNumberValue = watch('phoneNumber');
  const emailValue = watch('email');
  const additionalPhoneNumberValue = watch('additionalPhoneNumber');
  const birthDayValue = watch('birthDay');
  const issueDateValue = watch('issueDate');
  const additionalEmailValue = watch('additionalEmail');
  const signatureAccTextValue = watch('signatureAccText');
  const approvHarHabituachValue = watch("approvHarHabituach");
  const [isloading, setIsLoading] = useState(false);
  const [signature, setSignature] = useState(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const fieldLabels = {
    lastName: 'שם משפחה',
    firstName: 'שם פרטי',
    idNumber: 'תעודת זהות',
    cityName: 'עיר מגורים',
    street: 'רחוב',
    houseNumber: 'מספר בית',
    phoneNumber: 'טלפון נייד',
    email: 'דואר אלקטרוני',
    additionalPhoneNumber: 'טלפון נוסף',
    birthDay: 'תאריך לידה',
    issueDate: 'תאריך הנפקת תעודת זהות',
    additionalEmail: 'דואר אלקטרוני בן/בת זוג',
    signatureAccText: 'טקסט חתימה'
  };

  const [isAccessibleSignature, setIsAccessibleSignature] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [invalidFields, setInvalidFields] = useState([]);
  const [showFirst, setShowFirst] = useState(false);
  const [showSecond, setShowSecond] = useState(false);
  const [showThird, setShowThird] = useState(false);

  const getFieldStyles = (touched, error, value) => {
    const stringValue = typeof value === "string" ? value.trim() : value;
    const isValid = touched && !error && stringValue !== '' && stringValue !== undefined;
    return {
      color: isValid ? '#468847' : '',
      backgroundColor: isValid ? '#DFF0D8' : '',
      border: isValid ? '1px solid #D6E9C6' : '',
    };
  };

  const addHarigField = () => {
    append({ accountNumber: "", code: "" });
  };

  const removeHarigField = (index) => {
    remove(index);
  };

  const handleFormSubmit = async (formData) => {
    setIsLoading(true);
    const dataForServer = { ...formData, signContent: signature }
    dataForServer.price = initialData.price;
    const resp = await api.epSendHBData(dataForServer);
    try {
      if (resp.status === 200) {
        if(initialData.price > 0)
          window.location.href = initialData.invoiceUrl;
        else
        {
          setIsLoading(false);
          alert("הטופס נשלח בהצלחה");
          window.location.reload(); // Reload the page
          
        }
        //setIsFormSubmitted(true); //not needed because we will go to another url
        // alert("הטופס נשלח בהצלחה");
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      
    }
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    const isValid = await trigger();
    if (isValid) {
      handleSubmit(handleFormSubmit)();
    } else {
      const errorFields = Object.keys(errors);
      const errorLabels = errorFields.map(field => fieldLabels[field]);
      setInvalidFields(errorLabels);
      onOpen();
    }
  };
  useEffect(() => {
    reset();
  }, [isFormSubmitted]);

  return (
    <Box
      as="form"
      mt="20px"
      px="15px"
      onSubmit={handleSubmitClick} // שים לב שהולכים לפי הפונקציה של onSubmit
    >
      <Text variant={"runningText"} mb="10px">
        על מנת שנוכל לפנות לברר את זהות המוצרים שבידך עלינו לפנות בבקשה חד פעמית לכלל הגופים המוסדיים באמצעות המסלקה הפנסיונית / הר הביטוח. <br />
        לשם הגשת הבקשה עלינו לבצע רישום למסלקה הפנסיונית באמצעות יפוי כוח לאינפורמציה בלבד.<br />
        אנא מלא/י את טופס ההרשאה החד פעמית לסוכן לקבלת מידע נספח א' - מצורף, <b>וצרף/י צילום ת.ז. + ספח</b>.<br />
      </Text>
      <Stack as="fieldset">
        <Stack as="legend" w="100%" borderBottom={"1px solid #e5e5e5"} mb="20px">
          <Heading as="h2" variant={"h2"}>פרטים אישיים</Heading>
        </Stack>
        <GreyBox>
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
            <FormControl isInvalid={!!errors.lastName} flex="1">
              <FormLabel>שם משפחה
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.lastName, errors.lastName, lastNameValue)}
                autoComplete="off"
                {...register("lastName", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[\u0590-\u05FF\s]+$/, // Regular expression for Hebrew characters
                    message: "נא להזין משפחה בעברית בלבד",
                  },
                })}
              />
              {errors.lastName && (
                <FormErrorMessage color="primary.error">
                  {errors.lastName.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.firstName} flex="1">
              <FormLabel>שם פרטי
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.firstName, errors.firstName, firstNameValue)}
                autoComplete="off"
                {...register("firstName", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[\u0590-\u05FF\s]+$/, // Regular expression for Hebrew characters
                    message: "נא להזין שם בעברית בלבד",
                  },
                })}
              />
              {errors.firstName && (
                <FormErrorMessage color="primary.error">
                  {errors.firstName.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.idNumber} flex="1">
              <FormLabel>ת.ז.
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="ת.ז. תיקנית כולל ספרת ביקורת"
                aria-label="ת.ז. תיקנית כולל ספרת ביקורת"
                style={getFieldStyles(touchedFields.idNumber, errors.idNumber, idNumberValue)}
                autoComplete="off"
                {...register("idNumber", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^\d{9}$/, // Regular expression for exactly 9 digits
                    message: "ת.ז. לא תקינה",
                  },
                })}
              />
              {errors.idNumber && (
                <FormErrorMessage color="primary.error">
                  {errors.idNumber.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </Stack>
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
            <FormControl isInvalid={!!errors.cityName} flex="1">
              <FormLabel>עיר מגורים
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.cityName, errors.cityName, cityNameValue)}
                autoComplete="off"
                {...register("cityName", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[\u0590-\u05FF\s]+$/, // Regular expression for Hebrew characters
                    message: "נא להזין עיר בעברית בלבד",
                  },
                })}
              />
              {errors.cityName && (
                <FormErrorMessage color="primary.error">
                  {errors.cityName.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.street} flex="1">
              <FormLabel>רחוב
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.street, errors.street, streetValue)}
                autoComplete="off"
                {...register("street", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[\u0590-\u05FF\s]+$/, // Regular expression for Hebrew characters
                    message: "נא להזין רחוב בעברית בלבד",
                  },
                })}
              />
              {errors.street && (
                <FormErrorMessage color="primary.error">
                  {errors.street.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.houseNumber} flex="1">
              <FormLabel>מספר בית
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה"
                style={getFieldStyles(touchedFields.houseNumber, errors.houseNumber, houseNumberValue)}
                autoComplete="off"
                {...register("houseNumber", { required: "ערך חובה" })}
              />
              {errors.houseNumber && (
                <FormErrorMessage color="primary.error">
                  {errors.houseNumber.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </Stack>
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
            <FormControl isInvalid={!!errors.phoneNumber} flex="1">
              <FormLabel>טלפון נייד
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="דוגמא 055-5555555"
                style={getFieldStyles(touchedFields.phoneNumber, errors.phoneNumber, phoneNumberValue)}
                autoComplete="off"
                maxLength={11}
                {...register("phoneNumber", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^(0[23489]\d{7}|0[23489]-?\d{7}|05[0-9]\d{7}|05[0-9]-?\d{7})$/,
                    message: "מספר טלפון לא תקני",
                  },
                })}
              />
              {errors.phoneNumber && (
                <FormErrorMessage color="primary.error">
                  {errors.phoneNumber.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.email} flex="1">
              <FormLabel>דואר אלקטרוני
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="דוגמא: mail@example.com"
                style={getFieldStyles(touchedFields.email, errors.email, emailValue)}
                autoComplete="off"
                {...register("email", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "דואר אלקטרוני לא תקני",
                  },
                })}
              />
              {errors.email && (
                <FormErrorMessage color="primary.error">
                  {errors.email.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.additionalPhoneNumber} flex="1">
              <FormLabel>טלפון נוסף</FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="דוגמא 09-9999999"
                style={getFieldStyles(touchedFields.additionalPhoneNumber, errors.additionalPhoneNumber, additionalPhoneNumberValue)}
                autoComplete="off"
                maxLength={11}
                {...register("additionalPhoneNumber", {
                  pattern: {
                    value: /^(0[23489]\d{7}|0[23489]-?\d{7}|05[0-9]\d{7}|05[0-9]-?\d{7})$/,
                    message: "מספר טלפון לא תקני",
                  },
                })}
              />
              {errors.additionalPhoneNumber && (
                <FormErrorMessage color="primary.error">
                  {errors.additionalPhoneNumber.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </Stack>
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
            <FormControl isInvalid={!!errors.empName} maxW={{ base: '100%', md: '65.66%' }} flex="1">
              <FormLabel>שם מעסיק </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder=""
                {...register("empName")}
              />
              {errors.empName && (
                <FormErrorMessage color="primary.error">
                  {errors.empName.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </Stack>
        </GreyBox>
      </Stack>

      <Stack as="fieldset">
        <Stack as="legend" w="100%" borderBottom={"1px solid #e5e5e5"} mb="20px">
          <Heading as="h2" variant={"h2"}>הר הביטוח</Heading>
        </Stack>
        <Text variant={"runningText"}>
          על מנת שנוכל להתייחס גם לביטוחים נוספים שעל שמך, אנו מזמינים אותך לאשר לנו הפקת קובץ מידע מאתר "הר הביטוח" שהקים משרד האוצר ובכך להבטיח כי נראה תמונה מלאה יותר. בקובץ יופיעו כל פוליסות הפרט שעל שמך.
        </Text>
        <GreyBox gap="15px">
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
            <Checkbox
              size='sm'
              flex="1"
              defaultChecked
              {...register("approvHarHabituach")}
            >
              הנני מאשר להפיק מידע עבורי ממנוע "הר הביטוח" שהקים משרד האוצר
            </Checkbox>
            <Checkbox
              size='sm'
              defaultChecked
              flex="1"
              {...register("approvAdditioanlContact")}
            >
              הנני מאשר לפנות אלי בהמשך ולתת לי הצעת מחיר לביטוח רכב/דירה לפני החידוש השנתי שלהם
            </Checkbox>
          </Stack>
          <HStack flexDirection={{ base: "column", md: "row" }} gap={"30px"} mb="5px">
            {approvHarHabituachValue &&
              <FormControl isInvalid={!!errors.birthDay}>
                <FormLabel>תאריך לידה
                  <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
                </FormLabel>
                {/* <Input
                type="text"
                // defaultValue={initialData.birthDay || ""}
                placeholder="dd/MM/yyyy"
                aria-label="תאריך לידה בפורמט dd/MM/yyyy"
                style={getFieldStyles(touchedFields.birthDay, errors.birthDay, birthDayValue)}
                autoComplete="off"
                maxLength={11}
                {...register("birthDay", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/,
                    message: "תאריך לא תקני",
                  },
                })}
              /> */}
                <Controller
                  name="birthDay"
                  control={control}
                  defaultValue={""}
                  rules={{
                    required: "ערך חובה"
                  }}
                  render={({ field, ref }) => (
                    <DatePicker
                      calendarClassName="brand-cal"
                      {...field}
                      ref={ref}
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/MM/yyyy"
                      locale={he}
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={75}
                      minDate={new Date(1934, 0, 1)}
                      maxDate={new Date(2008, 11, 31)}
                      openToDate={!field.value ? new Date(1989, 0, 1) : undefined}
                      autoComplete="off"
                      customInput={
                        <input
                          maxLength={10}
                          aria-label="תאריך לידה הכנס בפורמט dd/mm/yyyy"
                          style={getFieldStyles(touchedFields.birthDay, errors.birthDay, birthDayValue)}
                        />
                      }
                    />
                  )}
                />
                {errors.birthDay && (
                  <FormErrorMessage color="primary.error">
                    {errors.birthDay.message}
                  </FormErrorMessage>
                )}
              </FormControl>
            }
            <FormControl isInvalid={!!errors.issueDate} w={{ base: "100%", md: approvHarHabituachValue ? "100%" : "calc(50% - 15px)" }}>
              <FormLabel>תאריך הנפקת תעודת זהות
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Controller
                name="issueDate"
                control={control}
                defaultValue={""}
                rules={{
                  required: "ערך חובה"
                }}
                render={({ field, ref }) => (
                  <DatePicker
                    calendarClassName="brand-cal"
                    {...field}
                    ref={ref}
                    selected={field.value}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/MM/yyyy"
                    locale={he}
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={75}
                    minDate={new Date(1950, 0, 1)}
                    maxDate={new Date()}
                    openToDate={!field.value ? new Date() : undefined}
                    autoComplete="off"
                    customInput={
                      <input
                        maxLength={10}
                        aria-label="תאריך הנפקה הכנס בפורמט dd/mm/yyyy"
                        style={getFieldStyles(touchedFields.issueDate, errors.issueDate, issueDateValue)}
                      />
                    }
                  />
                )}
              />
              {errors.issueDate && (
                <FormErrorMessage color="primary.error">
                  {errors.issueDate.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </HStack>

        </GreyBox>
      </Stack>

      <Stack as="fieldset">
        <Stack as="legend" w="100%" borderBottom={"1px solid #e5e5e5"} mb="20px" aria-label="בן/בת זוג"></Stack>
        <GreyBox gap="0">
          <Text variant={"runningText"} my="10px">
            אנו ממליצים להרחיב ולבחון את התמונה המלאה כך שתכלול את התוכניות של בן/בת הזוג שלך. לצורך זאת, אנא מלא את כתובת הדוא"ל של בן/בת הזוג.<br />
            אנו נפנה במייל נפרד לקבלת האישורים המתאימים וזאת בעלות של 31 ש"ח דמי רישום במסלקה.
          </Text>
          <HStack w={{ base: "100%", md: "51%" }} px="15px">
            <FormControl isInvalid={!!errors.additionalEmail}>
              <FormLabel>דואר אלקטרוני בן/בת זוג</FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder=""
                style={getFieldStyles(touchedFields.additionalEmail, errors.additionalEmail, additionalEmailValue)}
                autoComplete="off"
                {...register("additionalEmail", {
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "דואר אלקטרוני לא תקני",
                  },
                })}
              />
              {errors.additionalEmail && (
                <FormErrorMessage color="primary.error">
                  {errors.additionalEmail.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </HStack>
        </GreyBox>

        <Stack direction={"row"} justifyContent={"space-between"} wrap={"wrap"}>

          <Stack w={{ base: "100%", md: "calc(50% - 15px)" }} maxW={{ base: "100%", md: "50%" }}>
            <HStack>
              <Checkbox variant="disabledIcon" size='sm' marginInlineStart={"0"} defaultChecked disabled>
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} />
                <Text onClick={() => setShowFirst(!showFirst)} cursor="pointer" >הרשאת שימוש פרטנית לשימוש באתר הר הביטוח (נספח ה')</Text>
              </Checkbox>
              <Icon as={FaAngleDown} fontSize="16px" onClick={() => setShowFirst(!showFirst)} cursor="pointer" />
            </HStack>
            <GreyBox display={!showFirst && "none"}>
              <Collapse in={showFirst}>
                <Stack>
                  <Text variant={"runningText"}>לכבוד <b>{initialData?.name}</b></Text>
                  <Text variant={"runningText"}>א.ג.נ </Text>
                  <Stack>
                    <OrderedList pl="20px" fontSize={"14px"} m="0" display={"flex"} flexDirection={"column"} gap="10px">
                      <ListItem>
                        <Text variant={"runningText"}>
                          אני
                          {" "}
                          <Input
                            variant={"readonlyInput"}
                            readOnly
                            type="text"
                            value={`${firstNameValue?.trim() || ""} ${lastNameValue?.trim() || ""}`}
                            aria-label="שם מלא לקוח"
                          />
                          {" "}
                          החתום/ה מטה (שם מלא), תז
                          {" "}
                          <Input
                            variant={"readonlyInput"}
                            readOnly
                            type="text"
                            value={`${idNumberValue?.trim() || ""}`}
                            aria-label="ת.ז. לקוח"
                          />
                          {" "}
                          מייפה את כוחו/ה של חברת הביטוח / סוכן הביטוח
                          {" "}
                          <Input
                            variant={"readonlyInput"}
                            readOnly
                            type="text"
                            value={initialData?.name || ""}
                            aria-label="חברת הביטוח / סוכן הביטוח"
                          />
                          {" "}
                          לבצע חיפוש על שמי ועל שם ילדיי הקטינים <Link href="https://harb.cma.gov.il/" target="_blank">באתר הר הביטוח.</Link>
                        </Text>
                      </ListItem>
                      <ListItem>
                        טופס הרשאה זה יעמוד בתוקף לחמישה ימי עבודה. תאריך:
                        {" "}
                        <Input
                          variant={"readonlyInput"}
                          readOnly
                          type="text"
                          defaultValue={moment().format('DD/MM/YYYY')}
                        />
                        {" "}
                      </ListItem>
                    </OrderedList>
                  </Stack>
                  <Stack>
                    <Text variant={"runningText"}>
                      אני
                      {" "}
                      <Input
                        variant={"readonlyInput"}
                        readOnly
                        type="text"
                        value={initialData?.name || ""}
                      />
                      {" "}
                      החתום/ה מטה (שם מלא), מספר סוכן ביטוח/ ת.ז./ ח.פ./
                      הגורם המשווק :
                      {" "}
                      <Input
                        variant={"readonlyInput"}
                        readOnly
                        type="text"
                        value={initialData?.licenseNumber || ""}
                      />
                      {" "}
                      ,מתחייב/ת:
                    </Text>
                    <OrderedList pl="20px" fontSize={"14px"} m="0" display={"flex"} flexDirection={"column"} gap="10px">
                      <ListItem>
                        לעשות שימוש בנתונים שנמסרו לי בהתאם לבקשה זו בלבד.
                      </ListItem>
                      <ListItem>
                        שלא להחזיק בנתונים שנמסרו ולא לעשות בהם כל שימוש לאחר שיפוג תוקפה של הרשאה זו.</ListItem>
                    </OrderedList>
                    <Image src={`data:image/png;base64,${initialData?.agentSign}`} alt="חתימה" w="50%" alignSelf={"flex-end"} />
                    <Text variant={"runningText"} textAlign={"center"}>ולראיה באתי על החתום</Text>
                  </Stack>
                </Stack>
              </Collapse>
            </GreyBox>
          </Stack>

          <Stack w={{ base: "100%", md: "calc(50% - 15px)" }} maxW={{ base: "100%", md: "50%" }}>
            <HStack>
              <Checkbox variant="disabledIcon" size='sm' defaultChecked disabled>
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} />
                <Text onClick={() => setShowSecond(!showSecond)} cursor="pointer" >נספח רשימת מוצרים מוחרגים</Text>
              </Checkbox>
              <Icon as={FaAngleDown} fontSize="16px" onClick={() => setShowSecond(!showSecond)} cursor="pointer" />
            </HStack>
            <GreyBox display={!showSecond && "none"}>
              <Collapse in={showSecond}>
                <Stack gap="10px">
                  <Text variant={"runningText"}>לכבוד המסלקה (שם הגוף המוסדי)</Text>
                  <Text variant={"runningText"} fontSize={"18px"}>הנידון: רשימת מוצרים פנסיונים המוחרגים מייפוי הכוח</Text>
                  <HStack gap="30px">
                    <FormControl>
                      <FormLabel>שם הלקוח :</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={`${firstNameValue?.trim() || ""} ${lastNameValue?.trim() || ""}`}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>ת.ז. :</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={`${idNumberValue?.trim() || ""}`}
                      />
                    </FormControl>
                  </HStack>
                  <Stack>
                    <Text variant={"runningText"}>להלן פירוט המוצרים הפנסיונים המוחרגים מייפוי הכוח:</Text>
                    <Stack spacing={"30px"} direction={"row"} wrap={"wrap"} mt="15px">
                      <Text as="div" variant={"runningText"} flex="1">מספר חשבון הלקוח במוצר הפנסיוני/פוליסה</Text>
                      <Text as="div" variant={"runningText"} flex="1">מספר קידוד של המוצר הפנסיוני/פוליסה</Text>
                      <Text as="div" variant={"runningText"} flex="1" aria-hidden="true"></Text>
                    </Stack>
                    <Stack gap={"20px"}>
                      {fields.map((field, index) => (
                        <HStack key={field.id} gap="30px">
                          <FormControl isInvalid={!!errors.excludedProducts?.[index]?.accountNumber}>
                            <Input
                              type="text"
                              aria-label={""}
                              {...register(`excludedProducts.${index}.accountNumber`, {
                                pattern: {
                                  value: /^[0-9]+$/,
                                  message: "יש להזין ספרות בלבד",
                                },
                              })}
                            />
                            {errors.excludedProducts?.[index]?.accountNumber && (
                              <FormErrorMessage color="primary.error">
                                {errors.excludedProducts[index].accountNumber.message}
                              </FormErrorMessage>
                            )}
                          </FormControl>
                          <FormControl isInvalid={!!errors.excludedProducts?.[index]?.code}>
                            <Input
                              type="text"
                              aria-label={""}
                              {...register(`excludedProducts.${index}.code`, {
                                pattern: {
                                  value: /^[0-9]+$/,
                                  message: "יש להזין ספרות בלבד",
                                },
                              })}
                            />
                            {errors.excludedProducts?.[index]?.code && (
                              <FormErrorMessage color="primary.error">
                                {errors.excludedProducts[index].code.message}
                              </FormErrorMessage>
                            )}
                          </FormControl>
                          {index === 0 ? (
                            <Button variant={"addMore"} onClick={addHarigField}>+</Button>
                          ) : (
                            <Button variant={"addMore"} onClick={() => removeHarigField(index)}>-</Button>
                          )}
                        </HStack>
                      ))}
                    </Stack>
                    <Text variant={"runningText"} mt="10px">* החרגה של מוצר פנסיוני תתייחס לכל הכיסויים הביטוחים הכלולים בו.</Text>
                    <Text variant={"runningText"} textAlign={"center"}>ולראיה באתי על החתום</Text>
                  </Stack>
                </Stack>
              </Collapse>
            </GreyBox>
          </Stack>

          <Stack w="100%" maxW={{ base: "100%", md: "50%" }}>
            <HStack>
              <Checkbox variant="disabledIcon" size='sm' defaultChecked disabled>
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} />
                <Text onClick={() => setShowThird(!showThird)} cursor="pointer">השראה חד-פעמית לבעל רשיון לקבלת מידע (נספח א')</Text>
              </Checkbox>
              <Icon as={FaAngleDown} fontSize="16px" onClick={() => setShowThird(!showThird)} cursor="pointer" />
            </HStack>
            <GreyBox display={!showThird && "none"}>
              <Collapse in={showThird}>
                <Stack>
                  <Text variant={"runningText"}>לכל מען דבעי,</Text>
                  <Text variant={"runningText"} fontSize={"18px"}>מייפה הכוח (הלקוח)</Text>
                  <HStack gap="30px">
                    <FormControl>
                      <FormLabel>שם הלקוח :</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={`${firstNameValue?.trim() || ""} ${lastNameValue?.trim() || ""}`}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>ת.ז. :</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={`${idNumberValue?.trim() || ""}`}
                      />
                    </FormControl>
                  </HStack>
                  <HStack gap="30px">
                    <FormControl>
                      <FormLabel>כתובת :</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={`${streetValue?.trim() || ""} ${houseNumberValue?.trim() || ""}, ${cityNameValue?.trim() || ""}`}
                      />
                    </FormControl>
                  </HStack>
                  <Text variant={"runningText"} fontSize={"18px"}>מיופה הכוח (במקרה של בעל רשיון שהוא תאגיד, מיופה הכוח הינו התאגיד)</Text>
                  <HStack gap="30px">
                    <FormControl>
                      <FormLabel>שם התאגיד</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={initialData?.name || ""}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>רשיון מס'</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={initialData?.licenseNumber || ""}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>אשר הינו</FormLabel>
                      {/* <Select
                        disabled
                        bgColor={"#eee"}
                        type="text"
                        value={initialData?.organizationType || ""}
                      >
                        <option value={"יועץ פנסיוני"}>יועץ פנסיוני</option>
                        <option value={"סוכן ביטוח פנסיוני"}>סוכן ביטוח פנסיוני</option>
                        <option value={"משווק פנסיוני"}>משווק פנסיוני</option>

                      </Select> */}
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={initialData?.organizationType || ""}
                      />
                    </FormControl>
                  </HStack>
                  <HStack gap="30px">
                    <FormControl flex={1}>
                      <FormLabel>טלפון</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={initialData?.phone || ""}
                      />
                    </FormControl>
                    <FormControl flex={1}>
                      <FormLabel>מייל</FormLabel>
                      <Input
                        readOnly
                        bgColor={"#eee"}
                        type="text"
                        value={initialData?.email || ""}
                      />
                    </FormControl>
                    <FormControl flex={1} aria-hidden="true"></FormControl>
                  </HStack>
                  <Text variant={"runningText"}>
                    אני הח"מ, מייפה את כוחו של בעל הרשיון, או מטעמו, לפנות בשמי לכל גוף מוסדי לשם קבלת מידע אודות המוצרים הפנסיונים שלי, לשם מתן ייעוץ פנסיוני או שיווק פנסיוני באופן חד-פעמי או לשם מתן ייעוץ פנסיוני או שיווק פנסיוני לראשונה, כהכנה למתן ייעוץ פנסיוני או שיווק פנסיוני או שיווק פנסיוני מתמשך. העברת מידע אודותיי, כאמור לעיל, יכול שתעשה באמצעות סליקה פנסיונית.
                  </Text>
                  <Text variant={"runningText"}>
                    ייפוי כוח זה מתייחס לכל המוצרים הפנסיוניים המנוהלים עבורי בגוף מוסדי כלשהו נכון למועד חתימת הרשאה זו, מלבד המוצרים המנויים בטופס המצורף להרשאה זו (עבור כל גוף מוסדי בנפרד)
                  </Text>
                  <Text variant={"runningText"} fontWeight={"bold"} textAlign={"center"}>
                    שים לב ! אם לא יצוינו מוצרים פנסיונים בטופס המצ"ב, ההרשאה תתייחס לכל המוצרים הפנסיונים שברשותך
                  </Text>
                  <Text variant={"runningText"} fontWeight={"bold"} textAlign={"center"}>
                    *** הרשאה זאת תעמוד בתוקפה במשך 3 חודשים מיום חתימתה ***
                  </Text>
                  <Text variant={"runningText"} textAlign={"center"}>
                    ולראיה באתי על החתום
                  </Text>
                </Stack>
              </Collapse>
            </GreyBox>
          </Stack>
        </Stack>
      </Stack>


      <Stack as="fieldset" w={{ base: "100%", md: "50%" }}>
        <Stack as="legend" w="100%" borderBottom={"1px solid #e5e5e5"} mb="20px">
          <Heading as="h2" variant={"h2"}>חתימה</Heading>
        </Stack>
        <Checkbox size='sm'
          onChange={(e) => setIsAccessibleSignature(e.target.checked)}
        >
          חתימה נגישה
        </Checkbox>
        <AnimatePresence>
          {isAccessibleSignature ? (
            <ScaleFade initialScale={0.2} in={isAccessibleSignature} key="signature-text">
              <VStack mb="10px">
                <FormControl isInvalid={!!errors.signatureAccText} mt="20px" mb="5px" w="80%">
                  <VStack>
                    <FormLabel m="0">טקסט חתימה</FormLabel>
                    <FormHelperText fontSize={"12"} m="0">
                      אני מצהיר שהחתימה הנגישה שוות ערך לחתימה אורטוגרפית
                      <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
                    </FormHelperText>
                    <Input
                      type="text"
                      placeholder=""
                      style={getFieldStyles(touchedFields.signatureAccText, errors.signatureAccText, signatureAccTextValue)}
                      autoComplete="off"
                      {...register("signatureAccText", {
                        required: "ערך חובה",
                      })}
                    />
                    {errors.signatureAccText && (
                      <FormErrorMessage color="primary.error" bottom={"-20px"}>
                        {errors.signatureAccText.message}
                      </FormErrorMessage>
                    )}
                  </VStack>
                </FormControl>
              </VStack>
            </ScaleFade>
          ) : (
            <ScaleFade initialScale={0.2} in={!isAccessibleSignature} key="signature-component">
              <Signature onSignature={setSignature} clearSignaturOnSubmitForm={isFormSubmitted} />
            </ScaleFade>
          )}
        </AnimatePresence>
      </Stack>

      {initialData?.price !== 0 && (
  <Stack as="fieldset" w={{ base: "100%", md: "50%" }}>
    <Stack as="legend" w="100%" borderBottom={"1px solid #e5e5e5"} mb="20px">
      <Heading as="h2" variant={"h2"}>סכום: {initialData?.price} ש"ח</Heading>
    </Stack>
  </Stack>
)}

      <VStack p="30px 15px">
        <Button
          type="submit"
          variant="greenButton"
        >
          שלח
        </Button>
      </VStack>

      <AlertErrors isOpen={isOpen} onClose={onClose} invalidFields={invalidFields} />

      {isloading && <FullScreenLoader isOpen={true} />}

    </Box>
  )
}